import React from 'react';
import DrawerStyled from './bundle.esm2.js';
import Backdrop from '../Backdrop/bundle.esm.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const Drawer = (props) => {
  const { className, children, opened, onClose } = props;
  const { closeOnClickOutside, position = "right", backdropConfig } = props;
  const openedClass = opened ? "Drawer__opened" : "Drawer__closed";
  const onBackdropClicked = () => {
    var _a;
    if (closeOnClickOutside) {
      closeHandler();
      (_a = backdropConfig == null ? void 0 : backdropConfig.onClick) == null ? void 0 : _a.call(backdropConfig);
    }
  };
  const closeHandler = () => {
    onClose();
  };
  if (!opened)
    return null;
  return /* @__PURE__ */ React.createElement(Backdrop, __spreadProps(__spreadValues({
    name: "Drawer",
    onClick: onBackdropClicked
  }, backdropConfig), {
    opened: true
  }), /* @__PURE__ */ React.createElement(DrawerStyled, {
    className: `Drawer ${className} ${openedClass}`,
    position
  }, children));
};
Drawer.defaultProps = {
  className: "",
  opened: true,
  closeOnClickOutside: true,
  position: "right"
};

export { Drawer as default };
//# sourceMappingURL=bundle.esm.js.map
